import React, {PropsWithChildren, useContext, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {XpertKnowledgeBufferService} from '../../services/XpertKnowledgeBuffer'
import {XpertKnowledgeBufferDto} from '../../services/XpertKnowledgeBuffer/type'
import {getCookie, getCookieName} from '../../common/utils/cookieUtils'

interface XpertKnowledgeBufferContext {
  xpertKnowledgeBuffers: XpertKnowledgeBufferDto[]
  isLoading: boolean
}

const Context = React.createContext<XpertKnowledgeBufferContext>(null as any)

interface XpertKnowledgeBufferContextProviderProps {}

export const XpertKnowledgeBufferContextProvider: React.FC<PropsWithChildren<XpertKnowledgeBufferContextProviderProps>> = ({children}) => {
  const [xpertKnowledgeBuffers, setXpertKnowledgeBuffers] = useState<XpertKnowledgeBufferDto[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  const fetchXpertKnowledgeBuffers = async (isNoLoader?: boolean) => {
    if (!isNoLoader) setIsLoading(true)
    try {
      const xpertKnowledges = await XpertKnowledgeBufferService.getAllAdmin()
      setXpertKnowledgeBuffers(xpertKnowledges)
    } catch (error) {
      console.error('Error fetching XpertKnowledgeBuffers:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    const loadXpertKnowledgeBuffers = async (isNoLoader?: boolean) => {
      const authToken = getCookie(getCookieName())
      if (authToken) {
        await fetchXpertKnowledgeBuffers(isNoLoader)
      } else {
        navigate('/xpert-knowledge/error')
      }
    }
    if (location.pathname.includes('/xpert-knowledge/sso') || location.pathname.includes('/rag/sso')) return
    loadXpertKnowledgeBuffers()

    const intervalId = setInterval(() => {
      loadXpertKnowledgeBuffers(true)
    }, 60000)

    return () => clearInterval(intervalId)
  }, [getCookie(getCookieName())])

  return (
    <Context.Provider
      value={{
        xpertKnowledgeBuffers,
        isLoading,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useXpertKnowledgeBufferContext = () => useContext(Context)
